export default __webpack_public_path__ + "static/media/Minicard_Jh.faffa944.svg";